import React from 'react'
import PropTypes from 'prop-types'
import { FroalaTextEditor } from 'components/UIElements'

const MatrixQuestionsList = props => {
  const { isActive, item, itemId, preview, questionsError, updateMatrixQuestionLabel } = props

  const onMatrixQuestionLabelChange = (questionId, value) => {
    updateMatrixQuestionLabel(itemId, questionId, value)
  }

  return (
    <div className='matrix-questions-wrapper'>
      <div className='matrix-questions flexed'>
        <div className='flexed column start-aligned matrix-questions-list'>
          {item.questions_order.map((matrixQuestionId, index) => {
            return (
              <FroalaTextEditor
                key={`matrix-choice-label-${matrixQuestionId}`}
                value={item.questions[matrixQuestionId].label}
                onChange={newHtml => onMatrixQuestionLabelChange(matrixQuestionId, newHtml)}
                readOnly={preview}
                placeholder={`Question ${index + 1}`}
                showToolbar={isActive}
                moreText={{
                  includeAll: true,
                }}
                moreParagraph={{
                  includeAll: true,
                }}
                hasError={!!questionsError && item.questions[matrixQuestionId].label === ''}
              />
            )
          })}
        </div>
        <div className='questions-placeholder'>
          <i className='fas fa-ellipsis-h' />
        </div>
      </div>
      {questionsError && <p className='survey-error nrs-value matrix question-list'>{questionsError}</p>}
    </div>
  )
}

MatrixQuestionsList.propTypes = {
  isActive: PropTypes.bool,
  item: PropTypes.shape({
    questions_order: PropTypes.arrayOf(PropTypes.string),
    questions: PropTypes.shape({
      label: PropTypes.string,
    }),
  }),
  itemId: PropTypes.string,
  preview: PropTypes.bool,
  questionsError: PropTypes.string,
  updateMatrixQuestionLabel: PropTypes.func,
}

export default MatrixQuestionsList
